import { ExecutorContext } from '@/contexts/executor'
import type { PriorityExecutor } from '@lc/librunner'
import { useContext } from 'react'

export function useExecutor(): PriorityExecutor {
	const executor = useContext(ExecutorContext)
	if (!executor) throw new Error('not under ExecutorContext')
	return executor
}
